import React, { Component } from "react";
import { connect } from "react-redux";
import { cekCookies } from "../../../../../actions";
import __ from "lodash";
import { Row, Col, Alert } from "react-bootstrap";
import LoaderModal from "../../../../../components/modal/LoaderModal";
import { CONFIG_DEV } from "../../../../../config/ConfigDev";
import accountManagement from "../../../../../apis/accountManagement";
import { Bar, Doughnut } from "react-chartjs-2";
import "./ReportKU.css";
import response from "./respKu.json";
import { FooterReport, Gap, Line, LabelLevel } from "../../../../../components/Global";

class ReportKU extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            alertShow: false,
            error: false,
            aspekIntelegensi: [],
            emotionalQuotient: [],
            ketahananBelajar: [],
            detailSiswa: {},
            fetchDetailHasilAgcu: [],
            ketahananBelajar: [],
            detailAkademik: [],
            scoreIqGrafik: null,
            scoreIq: null,
            keteranganIq: null,
            rumpun1: null,
            rumpun2: null,
            rekomendasiSiswa: [],
        };
    }

    componentDidUpdate() {
        console.clear();
        console.log(response.data);
    }

    async componentDidMount() {
        this.setState({ isFetching: true, error: false });
        await this.props.cekCookies();
        console.clear();
        console.log("CEK ACCOUNT", this.props);

        if (!__.isEmpty(this.props.account)) {
            this.fetchReporting();
        }
    }

    async fetchReporting() {
        console.clear();
        const id = this.props.history.location.pathname.split("/");
        console.log("CEK A", id);
        const response = await accountManagement
            .get(CONFIG_DEV.PEMINATAN_KECAKAPAN_UMUM_REPORTING + id[2] / this.props.account.idSekolah + "&idjadwal=" + id[3] / this.props.account.idSekolah + "&idsiswa=" + id[4] / this.props.account.idSekolah)
            .catch(function (error) { });
        console.log(response);

        document.title = "SKU - " + response.data.data.detailSiswa.namaSiswa;

        if (response) {
            if (response.data.errorSchema.errorCode === CONFIG_DEV.SUCCESS_ERROR_CODE) {
                this.setState({
                    isFetching: false,
                    detailSiswa: response.data.data.detailSiswa,
                    scoreIq: response.data.data.scoreIq,
                    scoreIqGrafik: response.data.data.scoreIqGrafik,
                    keteranganIq: response.data.data.keteranganIq,
                    aspekIntelegensi: response.data.data.aspekIntelegensi,
                    emotionalQuotient: response.data.data.emotionalQuotient,
                    ketahananBelajar: response.data.data.ketahananBelajar,
                    rumpun1: response.data.data.rumpun1,
                    rumpun2: response.data.data.rumpun2,
                    rekomendasiSiswa: response.data.data.listRekomendasiSiswa,
                });
            } else {
                this.setState({
                    isFetching: false,
                    error: true,
                    alertShow: true,
                    resMessage: response.data.errorSchema.errorMessage,
                });
            }
        } else {
            this.setState({
                isFetching: false,
                error: true,
                alertShow: true,
                resMessage: response.data.errorSchema.errorMessage,
            });
        }
        (function () {
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.src = "/assets/js/easypiechart-data.js";
            document.getElementsByTagName("head")[0].appendChild(script);
        })();
        console.log("rumpun", response.data);
    }

    renderChart() {
        let data = [this.state.scoreIq];
        let label = ["NILAI SISWA"];

        return (
            <Bar
                data={{
                    labels: label,
                    datasets: [
                        {
                            label: "Nilai Siswa",
                            data: data,
                            backgroundColor: ["#2E80D1"],
                        },
                    ],
                }}
                options={{
                    legend: {
                        labels: {
                            fontSize: 0,
                        },
                        position: "top",
                    },
                    plugins: {
                        datalabels: {
                            display: false,
                        },
                        outlabels: {
                            display: false,
                        },
                    },
                    scales: {
                        y: {
                            // min: 10,
                            max: 150,
                            ticks: {
                                // forces step size to be 50 units
                                stepSize: 20,
                            },
                        },
                    },
                }}
                height={400}
            />
        );
    }

    render() {
        const today = new Date();
        const suflix = today.getHours() >= 12 ? " PM" : " AM";
        const dateTime = today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear() + ", " + today.getHours() + "." + today.getMinutes() + suflix;
        const { detailSiswa, scoreIq, keteranganIq, aspekIntelegensi, emotionalQuotient, ketahananBelajar, rumpun1, rumpun2, error, rekomendasiSiswa } = this.state;

        return (
            <div className="container-fluid" style={{ padding: "10px", width: "1000px" }}>
                <LoaderModal isFetching={this.state.isFetching} />
                {this.loadAlert()}
                {!error && (
                    <>
                        <div className="cardLine">
                            {/* header */}
                            <div className="pnl-header">
                                <div className="card-page">
                                    <span style={{
                                        fontSize: '26px',
                                        color: '#FFF',
                                        fontWeight: 500,
                                        fontFamily: 'lucida grande'
                                    }}>01</span>
                                </div>
                                <div className="pnl-date">
                                    https://eduprime.co.id/
                                </div>
                            </div>
                            <div className="header-first-page" style={{ padding: '0px' }}>
                                <div className="title-header2" style={{ color: '#015E56' }}>HASIL TES KECAKAPAN UMUM SISWA </div>
                                <div className="text-header" style={{ padding: '0px' }}>
                                    <div className="label-sub-tit">
                                        <span className="sub-title-header" style={{ color: '#FFF' }}>{detailSiswa.namaSekolah}</span>
                                    </div>
                                </div>
                                <div className="image-header">
                                    <div className="logo-edu">
                                        <img src="https://eduprime.co.id/static/images/LOGO_EDUPRIME_2.png" width={"167px"} />
                                    </div>
                                </div>
                            </div>

                            <div className="pnl-profile" style={{ marginBottom: '0px' }}>
                                <div className="card-profile">
                                    <div>
                                        <img src="/assets/image/icon-sekolah.svg" width="60px" alt="" />
                                    </div>
                                    <div>
                                        <span className="label-profile-name">Nama Sekolah</span>
                                        <p className="label-profile-value">{detailSiswa.namaSiswa}</p>
                                    </div>
                                </div>
                                <div className="card-profile">
                                    <div>
                                        <img src="/assets/image/mdi_date.svg" width="60px" alt="" />
                                    </div>
                                    <div>
                                        <span className="label-profile-name">Tanggal Lahir</span>
                                        <p className="label-profile-value" style={{ verticalAlign: "middle" }}>{detailSiswa.tglLahir}</p>
                                    </div>
                                </div>
                                <div className="card-profile">
                                    <div>
                                        <img src="/assets/image/mdi_child.svg" width="60px" alt="" />
                                    </div>
                                    <div>
                                        <span className="label-profile-name">Usia</span>
                                        <p className="label-profile-value">{detailSiswa.umur}</p>
                                    </div>
                                </div>
                            </div>

                            <div className="flex-pnl">
                                <div style={{ width: '50%' }}>
                                    <div className="card-profile">
                                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                            <div className="easypiechart chart" id="easypiechart-blue" data-percent={scoreIq}>
                                                <div className="label_persentase_potensi_chart">
                                                    <span className="persentase_potensi">{scoreIq}%</span>
                                                    <br />
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', gap: '10px' }}>
                                            <img src="/assets/image/centang-kecil-hijau.svg" width="30px" alt="" />
                                            <h4 style={{ fontWeight: "bolder", margin: '4px 0 0 0' }}>{keteranganIq}</h4>
                                        </div>
                                        <Gap height={10} />
                                        <span style={{ fontSize: '18px', color: '#757575', textAlign: 'center' }}>
                                            Skor tes kecakapan umum merupakan konversi dari skor tes potensi
                                        </span>
                                    </div>
                                    <div className="card-profile">
                                        <h5 style={{ fontWeight: "bolder", textAlign: "left" }}>Kelanjutan Studi</h5>
                                        <Gap height={10} />
                                        <div style={{ display: "inline-block", width: "100%", textAlign: "left", marginBottom: 5 }}>
                                            <div style={{ display: "inline-block", width: "10%" }}>
                                                <img src="/assets/image/centang-kecil-hijau.svg" width="30px" alt="" />
                                            </div>
                                            <div style={{ display: "inline-block", width: "90%", verticalAlign: "middle" }}>
                                                <span style={{ fontSize: '18px' }}>Rumpun Program Studi</span>
                                                <span style={{ fontSize: '16px', color: "#6C757D", display: "block" }}>{rumpun1}</span>
                                            </div>
                                        </div>
                                        <div style={{ display: "inline-block", width: "100%", textAlign: "left", marginBottom: 5 }}>
                                            <div style={{ display: "inline-block", width: "10%" }}>
                                                <img src="/assets/image/centang-kecil-hijau.svg" width="30px" alt="" />
                                            </div>
                                            <div style={{ display: "inline-block", width: "90%", verticalAlign: "middle" }}>
                                                <span style={{ fontSize: '18px' }}>Rumpun Program Studi</span>
                                                <span style={{ fontSize: '16px', color: "#6C757D", display: "block" }}>{rumpun2}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: '50%' }}>
                                    <div className="card-profile">
                                        <h5 style={{ fontWeight: "bolder", textAlign: "left" }}>Aspek Intelegensi</h5>
                                        {aspekIntelegensi.map((val, i) => (
                                            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', margin: '5px 0' }}>
                                                <div style={{ width: '50%' }}>
                                                    <span style={{ fontSize: '14px', fontWeight: '400', color: '#757575' }}>
                                                        {val.nama}
                                                    </span>
                                                </div>
                                                <div style={{ width: '50%' }}>
                                                    <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                                                        <LabelLevel
                                                            level={val.keterangan == "ling-biru-iq" ? "Sangat Baik" : val.keterangan == "ling-hijau-iq" ? "Baik" : val.keterangan == "ling-orange-iq" ? "Cukup" : "Kurang"}
                                                            color={'#FFF'}
                                                            bgColor={val.keterangan == "ling-biru-iq" ? "#0097CE" : val.keterangan == "ling-hijau-iq" ? "#03C46B" : val.keterangan == "ling-orange-iq" ? "#FEBC04" : "#C4161C"}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="card-profile">
                                        <h5 style={{ fontWeight: "bolder", textAlign: "left" }}>Emotional Quotient</h5>
                                        {emotionalQuotient.map((val, i) => (
                                            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', margin: '5px 0' }}>
                                                <div style={{ width: '50%' }}>
                                                    <span style={{ fontSize: '14px', fontWeight: '400', color: '#757575' }}>
                                                        {val.nama}
                                                    </span>
                                                </div>
                                                <div style={{ width: '50%' }}>
                                                    <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                                                        <LabelLevel
                                                            level={val.keterangan == "ling-biru-iq" ? "Sangat Baik" : val.keterangan == "ling-hijau-iq" ? "Baik" : val.keterangan == "ling-orange-iq" ? "Cukup" : "Kurang"}
                                                            color={'#FFF'}
                                                            bgColor={val.keterangan == "ling-biru-iq" ? "#0097CE" : val.keterangan == "ling-hijau-iq" ? "#03C46B" : val.keterangan == "ling-orange-iq" ? "#FEBC04" : "#C4161C"}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="card-profile">
                                        <h5 style={{ fontWeight: "bolder", textAlign: "left" }}>Ketahanan Belajar</h5>
                                        {ketahananBelajar.map((val, i) => (
                                            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', margin: '5px 0' }}>
                                                <div style={{ width: '50%' }}>
                                                    <span style={{ fontSize: '14px', fontWeight: '400', color: '#757575' }}>
                                                        {val.nama}
                                                    </span>
                                                </div>
                                                <div style={{ width: '50%' }}>
                                                    <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                                                        <LabelLevel
                                                            level={val.keterangan == "ling-biru-iq" ? "Sangat Baik" : val.keterangan == "ling-hijau-iq" ? "Baik" : val.keterangan == "ling-orange-iq" ? "Cukup" : "Kurang"}
                                                            color={'#FFF'}
                                                            bgColor={val.keterangan == "ling-biru-iq" ? "#0097CE" : val.keterangan == "ling-hijau-iq" ? "#03C46B" : val.keterangan == "ling-orange-iq" ? "#FEBC04" : "#C4161C"}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <Gap height={40} />
                        <div className="reportFooter">
                            <FooterReport color={"#015E56"} date={dateTime} />
                        </div>

                        <div id="btn_print">
                            <div className="fixed_button">
                                <button className="btn btn-outline-primary  pull-right" title="Print Report" style={{ marginRight: "1em" }} onClick={() => window.print()}>
                                    <li className="fa fa-print"></li>
                                </button>
                            </div>
                        </div>
                    </>
                )}
            </div>
        );
    }

    loadAlert = () => {
        const { alertShow } = this.state;

        if (alertShow) {
            return (
                <Alert variant="warning" onClose={() => this.setState({ alertShow: false })} dismissible>
                    <strong>{this.state.resMessage}</strong>
                </Alert>
            );
        }
    };
}

const mapStateToProps = (state) => {
    return {
        account: state.account,
    };
};

export default connect(mapStateToProps, { cekCookies })(ReportKU);
